module.exports = require("lodash/isBoolean");